import { PageContainer } from '@components/PageContainer';
import { RoutedTabs } from '@components/RoutedTabs';
import { DownloadIcon, FileAddIcon } from '@gurupay/gp-ui-library';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

const Statements = () => {
	const { t } = useTranslation('', { keyPrefix: 'statements' });
	const [search] = useSearchParams();
	const id = search.get('uuid');

	const back = id ? `/accounts/${id}` : '/accounts';
	const q = id ? `?uuid=${id}` : '';

	const tabs = [
		{
			label: t('generate'),
			to: `generate${q}`,
			icon: <FileAddIcon className="w-space-16 h-space-16" />,
		},
		{
			label: t('download'),
			to: `download${q}`,
			icon: <DownloadIcon className="w-space-16 h-space-16" />,
		},
	];

	return (
		<PageContainer backUrl={back} title={t('statements')}>
			<RoutedTabs tabs={tabs} />
		</PageContainer>
	);
};

export default Statements;
